import React from "react";

import "./Body.scss";

interface IProps extends React.HTMLAttributes<HTMLDivElement> {
    children?: React.ReactNode;
}

export default function Body({ children, className, ...props }: IProps) {
    const classNames = ["userful-body", className].filter(Boolean).join(" ");

    return (
        <div className={classNames} {...props}>
            {children}
        </div>
    );
}
